"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isHTTPErrorResponse = exports.isHTTPError = void 0;
const isHTTPError = (e) => {
    return (e instanceof Error &&
        'response' in e &&
        typeof e.response === 'object' &&
        e.response !== null &&
        'status' in e.response &&
        typeof e.response.status === 'number');
};
exports.isHTTPError = isHTTPError;
const isHTTPErrorResponse = (response) => response.status >= 400 &&
    typeof response.data === 'object' &&
    response.data !== null &&
    'error' in response.data &&
    typeof response.data.error === 'string';
exports.isHTTPErrorResponse = isHTTPErrorResponse;
